import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Loader2 } from "lucide-react";
import api from "@/lib/api";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setMessage("If an account exists for this email, a password reset link has been sent.");
    } catch (err) {
      setError(err.response?.data?.message || "An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-6 bg-zinc-50">
      <div className="w-full max-w-sm space-y-6 bg-white p-8 rounded-xl shadow-sm border border-border">
        <div>
          <div className="overline text-zinc-500 mb-2">Reset Password</div>
          <h2 className="font-heading font-black text-3xl tracking-tighter">Forgot Password</h2>
          <p className="text-sm text-zinc-500 mt-1">Enter your email to receive a reset link.</p>
        </div>

        <form onSubmit={onSubmit} className="space-y-6" data-testid="forgot-password-form">
          <div className="space-y-4">
            <div className="space-y-2">
              <Label htmlFor="email">Email</Label>
              <Input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                data-testid="forgot-email-input"
              />
            </div>
          </div>

          {error && (
            <div className="text-sm text-red-700 bg-red-50 border border-red-200 px-3 py-2 rounded-md">
              {error}
            </div>
          )}

          {message && (
            <div className="text-sm text-green-700 bg-green-50 border border-green-200 px-3 py-2 rounded-md">
              {message}
            </div>
          )}

          <Button
            type="submit"
            className="w-full bg-zinc-900 text-white hover:bg-zinc-800 h-11"
            disabled={loading}
            data-testid="forgot-submit"
          >
            {loading ? <Loader2 className="w-4 h-4 mr-2 animate-spin" /> : null}
            Send Reset Link
          </Button>

          <div className="text-sm text-zinc-500 text-center pt-4 border-t border-border">
            Remember your password?{" "}
            <Link to="/login" className="text-zinc-900 hover:underline">
              Back to login
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
}
